import UISelect from 'UIComponents/input/UISelect';
import CampaignToAutoSelectPopover from './CampaignToAutoSelectPopover';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CampaignSelectWithAutoSelectPopover({
  forceClose,
  hasDismissedPopover,
  onCampaignAutoSelectChange,
  setHasDismissedPopover,
  setValueFromAttributes,
  valueFromProps,
  withCampaignAutoSelectPopover,
  uiSelectProps
}) {
  const {
    'aria-labelledby': ariaLabelledBy,
    'data-test-id': dataTestId,
    className,
    dropdownClassName,
    error,
    buttonUse,
    anchorType,
    itemComponent,
    ButtonContent,
    id,
    disabled,
    placeholder,
    menuWidth,
    inputRef,
    clearable,
    dropdownFooter,
    loadOptions,
    options,
    minimumSearchCount,
    onSelectedOptionChange,
    searchable,
    value,
    autoload,
    onOpenChange,
    multi
  } = uiSelectProps;
  const campaignSelect = /*#__PURE__*/_jsx(UISelect, {
    "aria-labeledby": ariaLabelledBy,
    "data-test-id": dataTestId,
    className: className,
    dropdownClassName: dropdownClassName,
    error: error,
    buttonUse: buttonUse,
    anchorType: anchorType,
    itemComponent: itemComponent,
    ButtonContent: ButtonContent,
    id: id,
    disabled: disabled,
    placeholder: placeholder,
    menuWidth: menuWidth,
    inputRef: inputRef,
    clearable: clearable,
    dropdownFooter: dropdownFooter,
    loadOptions: loadOptions,
    options: options,
    minimumSearchCount: minimumSearchCount,
    onSelectedOptionChange: onSelectedOptionChange,
    searchable: searchable,
    value: value,
    autoload: autoload,
    onOpenChange: onOpenChange,
    multi: multi
  });
  return withCampaignAutoSelectPopover ? /*#__PURE__*/_jsx(CampaignToAutoSelectPopover, {
    forceClose: forceClose,
    hasDismissedPopover: hasDismissedPopover,
    onSelect: onCampaignAutoSelectChange,
    setHasDismissedPopover: setHasDismissedPopover,
    setValueFromAttributes: setValueFromAttributes,
    valueFromProps: valueFromProps,
    children: campaignSelect
  }) : campaignSelect;
}